module.exports = __webpack_public_path__ + "img/setting.c9a704bc.svg";